import { createSelector } from 'reselect';
import config from '../../config';

const selectPanels = state => state.app.panels;

export const selectConfig = () => config;

const selectPanelIdFromProps = (_, props) => props.id;

const selectPanel = createSelector(
  selectPanels,
  selectPanelIdFromProps,
  (panels, panelId) => panels[panelId],
);

export const selectTypeForPanel = createSelector(
  selectPanel,
  (panel) => panel.type,
);

export const selectConfigForPanel = createSelector(
  selectPanel,
  panel => panel.config,
)

export const selectTitleForPanel = createSelector(
  selectTypeForPanel,
  type => type ? config.visuals[type].title : 'Select a visual',
);

export const selectOptions = createSelector(
  selectConfig,
  config => Object.entries(config.visuals).map(([name, { title }]) => ({ name, title })),
)



// WEBPACK FOOTER //
// ./src/components/Panel/selectors.js